import { Typography } from "@mui/material";
import { Fragment, React } from "react";
import { CustomDiv } from "../../../../../modules/chat-bot/style";
import CommonButton from "../../../../../component/Button";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../../../modules/common-components/StyledComponents";
import { CustomizeSpan } from "../../../../../modules/jobs/style";
import OurPlan from "../../../../../modules/organization-setup/plan-expired/OurPlan";
import { checkEndDate, HandleSkeletion } from "../../../../../utils/constants";

export default function Plan({
  handleChange,
  handleExpand,
  handleClickStripeOpen,
  checked,
  planData,
  handlePlanCancel,
  localStorageData,
}) {
  return (
    <CustomDiv>
      <CommonGrid2
        container
        size={12}
        padding={"1.5rem"}
        border="3px solid #7F56D9"
        borderRadius={"10px"}
        position={"relative"}
      >
        <CustomDiv
          position="absolute"
          padding="8px 1rem"
          background="#7F56D9"
          color="#fff"
          top="0px"
          right="0px"
          borderRadius="0px 7px 0px 10px"
        >
          {planData?.current_plan?.cancelled
            ? `Access available till ${checkEndDate(
                planData?.current_plan?.days_left
              )}`
            : "Current Plan"}
        </CustomDiv>
        <CommonGrid2
          size={12}
          gap={"10px"}
          display={"flex"}
          flexDirection={"column"}
        >
          {planData.loading ? (
            <HandleSkeletion height={100} />
          ) : (
            <Fragment>
              <Typography color="#7F56D9" variant="h4">
                {planData?.current_plan?.base_name} -{" "}
                <CustomizeSpan
                  color="#7F56D9"
                  fontSize={"20px"}
                  fontWeight={600}
                >
                  {localStorageData?.agency_type === "Recruiting Agency"
                    ? "Agency"
                    : localStorageData?.agency_type === "Delivery Agency"
                    ? "Delivery"
                    : localStorageData?.agency_type === "VMS"
                    ? "Supply Network"
                    : localStorageData?.agency_type === "Hiring Teams"
                    ? "Client"
                    : "Candidate"}
                </CustomizeSpan>
              </Typography>

              <Typography color="#223548" variant="h1">
                {planData?.current_plan?.base_name === "Trial" && "Free"}{" "}
                <CustomizeSpan color="#A9B4BE" fontSize="15px">
                  {planData?.current_plan?.description}
                </CustomizeSpan>
              </Typography>
            </Fragment>
          )}
          <CommonGrid2
            spacing={2}
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"end"}
          >
            <CommonGrid2
              size={12}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
              width={"auto"}
            >
              {planData.loading ? (
                <HandleSkeletion
                  height={50}
                  width={300}
                  transform={"scale(1)"}
                />
              ) : (
                <Fragment>
                  <Typography variant="h6" color="#5B738B">
                    Status
                  </Typography>
                  <StatusChange>
                    <DotColor color={"green"} />
                    {`${planData?.current_plan?.days_left} days left`}
                  </StatusChange>
                </Fragment>
              )}
            </CommonGrid2>
            <CommonGrid2>
              {planData.loading ? (
                <HandleSkeletion
                  height={50}
                  width={100}
                  transform={"scale(1)"}
                />
              ) : (
                <Fragment>
                  {planData?.current_plan?.base_name === "Trial" ? (
                    <CommonButton
                      value={"Request Trial Extension"}
                      padding={"6px 1rem"}
                      variant="outlined"
                      color="#344054"
                      width={"100%"}
                      fontWeight={"600"}
                      fontSize={"15px"}
                      border={"#D0D5DD"}
                    />
                  ) : (
                    <CommonButton
                      value={"Cancel Plan"}
                      padding={"6px 1rem"}
                      variant="outlined"
                      color="#D80027"
                      width={"100%"}
                      fontWeight={"600"}
                      fontSize={"15px"}
                      border={"#D0D5DD"}
                      disabled={planData?.current_plan?.cancelled}
                      onClick={handlePlanCancel}
                    />
                  )}
                </Fragment>
              )}
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
      <OurPlan
        monthData={planData}
        handleChange={handleChange}
        handleExpand={handleExpand}
        handleClickStripeOpen={handleClickStripeOpen}
        checked={checked}
        loading={planData.loading}
      />
    </CustomDiv>
  );
}
